export const MAIN_MAP_ID = 5053;
export const HISTAMINE_MAP_ID = 5052;
export const PRKN_SUBSTRATES_MAP_ID = 5054;
export const MODEL_IDS_MOCK = [HISTAMINE_MAP_ID, MAIN_MAP_ID, PRKN_SUBSTRATES_MAP_ID];
